import React from 'react'
import { motion, AnimatePresence } from "framer-motion";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import OTableHeadRejected from 'components/reusable/OTableHead';
import helpers from 'utils/helpers';
import { AiFillEye } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import OModal from "components/OModal";

const CancelledTable = ({ filteredData, sort, setSort, page }) => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    return (
        <div className="overflow-x-auto relative rounded-lg border">

            <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
                <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400 dark:border-[#ffffff38]">
                    <tr>
                        <th scope="col" className="py-3 px-3 text-center">
                            {t("S.NO")}
                        </th>

                        <OTableHeadRejected sort={sort} name={"Customer"} setSort={setSort} />
                        <OTableHeadRejected sort={sort} name={t("Mobile Number")} setSort={setSort} />
                        <OTableHeadRejected sort={sort} name={"Service Type"} setSort={setSort} />
                        <OTableHeadRejected sort={sort} name={"Booking ID"} setSort={setSort} classTd='text-right' />
                        <OTableHeadRejected sort={sort} name={"Assign Driver"} setSort={setSort} />
                        <OTableHeadRejected sort={sort} name={"Booking Type"} setSort={setSort} />
                        <OTableHeadRejected sort={sort} name={"Booking Date & Time"} setSort={setSort} />
                        <OTableHeadRejected sort={sort} name={"Earnings On Completion"} setSort={setSort} tableClass='text-right' />
                        {/* <OTableHeadRejected sort={sort} name={"Cancelled By"} setSort={setSort} /> */}
                        <OTableHeadRejected sort={sort} name={"Created At"} setSort={setSort} tableClass='text-center'/>
                        <OTableHeadRejected sort={sort} name={t("Action")} setSort={setSort} />

                    </tr>
                </thead>
                <tbody>
                    <AnimatePresence>
                        {filteredData?.map((item, idx) => (
                            <motion.tr
                                key={item?._id}
                                initial={{ opacity: 0, y: 5 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: idx * 0.05 }}
                                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                            >

                                <td className="py-3 px-4 text-center border-r font-medium text-gray-900  dark:text-white">  {idx + 1 + 10 * (page - 1)}</td>
                                <td className="py-3 px-4 border-r">{helpers.capitalizeFirstWord(item?.userDetails?.fullName)}</td>
                                <td className="py-3 px-4 border-r">{helpers.ternaryCondition(item?.userDetails?.mobile, ('+' + item?.userDetails?.countryCode + '-' + item?.userDetails?.mobile), 'N/A')}</td>
                                <td className="py-3 px-4 border-r">{helpers.capitalizeFirstWord(item?.serviceDetails?.name)}</td>
                                <td className="py-3 px-4 border-r text-right">#{item?.bookingId}</td>
                                <td className="py-3 px-4 border-r">{helpers.capitalizeFirstWord(item?.driverDetails?.fullName)}</td>
                                <td className="py-3 px-4 border-r">{helpers.capitalizeFirstWord(item?.bookingType)}</td>
                                <td className="py-3 px-4 border-r">{helpers.ternaryCondition(item?.bookingType == 'immediate', 'Immediate', helpers.getDateAndTime(item?.createdAt))}</td>
                               
                                <td className="py-3 px-4 font-semibold border-r text-right">
                                    {helpers.formattedAmount(item?.spEarning || 0)}
                                </td>
                                {/* <OModal
                                    trigger={<td className={`py-2 px-4 border-r dark:border-[#ffffff38] ${helpers.ternaryCondition(item?.cancellationReason?.length > 60, ' cursor-pointer', '')}`} onClick={(e) => item?.cancellationReason?.length < 60 && e.preventDefault()}>{helpers.capitalizeFirstWord(item?.cancelledBy)} <br/>   {helpers.ternaryCondition(item?.cancellationReason,('('+helpers.ternaryCondition(item?.cancellationReason?.length > 60, `${item?.cancellationReason?.slice(0, 60)?.trim()}... `, (item?.cancellationReason||'N/A'))+')'),'')}</td>}
                                    title={'View Cancellation Reason'}
                                >
                                    <td className="py-2 px-1 break-all text-right">{helpers.capitalizeFirstWord(item?.cancellationReason)}</td>
                                </OModal> */}

                                <td className="py-3 px-4 border-r text-center">{helpers.getDateAndTime(item?.createdAt)}</td>
                                <td
                                    onClick={() => {
                                        navigate(`/track-services/view/${item?._id}`);
                                    }}
                                    className="px-2 py-2 border-l text-center hover:bg-white hover:text-LightBlue dark:hover:bg-transparent "
                                    title={"View"}
                                >
                                    <span className="flex justify-center items-center h-full">
                                        <AiFillEye
                                            className="text-slate-600 cursor-pointer"
                                            size={23}
                                        />
                                    </span>
                                </td>
                            </motion.tr>
                        ))}
                    </AnimatePresence>

                    {isEmpty(filteredData) ? (
                        <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                            <td className="py-4 px-6" colSpan={12}>
                                {t("O_NO_RECORD_FOUND")}
                            </td>
                        </tr>
                    ) : null}
                </tbody>
            </table>



        </div>
    )
}

export default CancelledTable